import { gql, useQuery } from "@apollo/client";
import {
    ViewRepContactQueryQuery,
    ViewRepContactQueryQueryVariables,
    RepContact
} from "../../../../../../schemaTypes";

export const viewRepContactQuery = gql`
    query ViewRepContactQuery($id: String!) {
        viewRepContact(id: $id) {
            id
            role
            admin {
                id
                firstname
                lastname
                email
                phone
                createdAt
                updatedAt
            }
            user {
                id
                admin {
                firstname
                lastname
                email
                }
            }
            createdAt
            updatedAt
        }
    }
`;

export function useViewRepContact(id: string) {
    const { data, loading, error } = useQuery<
        ViewRepContactQueryQuery,
        ViewRepContactQueryQueryVariables
    >(viewRepContactQuery, {
        variables: { id },
        skip: !id
    });

    return {
        repContact: data?.viewRepContact as RepContact | undefined,
        loading,
        error
    };
}
